import { feedbackUIAvailabilityAtom } from '@atoms';
import { APP_NAME } from '@utils/constants';
import { THandleCoreError, useCoreError } from 'fe-core';
import { useAtom } from 'jotai';
import { useErrorMap } from '@fe-learner-common/hooks/useErrorMap';

export const useError = () => {
  const [feedbackUIAvailability] = useAtom(feedbackUIAvailabilityAtom);
  const handleCoreError = useCoreError();
  const errorMap = useErrorMap();

  type THandleContextualError = Omit<
    THandleCoreError,
    'consumer' | 'feedbackUIAvailability'
  >;
  const emitError = ({ error, errorMapOverride }: THandleContextualError) => {
    handleCoreError({
      feedbackUIAvailability,
      consumer: APP_NAME,
      error,
      errorMap,
      errorMapOverride,
    });
  };

  return emitError;
};
